import React, { useState } from 'react'
import hook from "src/app/hook"


export default function useGetData({ url, Data, method }) {
    if (!url) throw new Error("url is required")
    const [data, setData] = useState(null)
    const [sort, setSort] = useState(undefined)
    const [order, setOrder] = useState(undefined)
    const [limit, setLimit] = useState(20)
    const [offset, setOffset] = useState(0)
    const [Query, setQuery] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(null)
    const [error, setError] = useState(null)
    const fetchData = async () => {
        try {
            setLoading(true)
            const urlData = {
                limit,
                offset,
                search: Query,
                "order": order,
                "sort": sort,
                "isDownload": "0",
                ...Data
            }
            const data = await hook.useAxios({ url, "data": urlData, method })
            setData(data)
            setTotalCount(data?.totalCount)
        } catch (error) {
            setError(error)
            console.log('error useGetData :', error);
        } finally {
            setLoading(false)
        }
    }
    React.useEffect(() => {
        fetchData()
    }, [sort, order, Query, offset, limit])
    return {
        data, sort, order, setSort, setOrder,
        offset, setOffset, limit, setLimit,
        Query, setQuery, loading, totalCount, fetchData, error
    }

}
